import React, { useState } from 'react'
import styled from 'styled-components'
import MobileTileRow from '@components/Table/Mobile/MobileTileRow'

export default ({ row, columns, ExpandedRowComponent }) => {
    const [expanded, setExpanded] = useState(false)

    return (
        <MobileTileMainContainer>
            <TileTable>
                <TileHeader>
                    {columns.map((col, ci) => {
                        return (
                            !col.hidden && (
                                <MobileTileRow
                                    key={'tile-header-row-' + ci}
                                    row={row}
                                    col={col}
                                    isHeader={true}
                                />
                            )
                        )
                    })}
                </TileHeader>
                <TileDataBlock>
                    {columns.map((col, ci) => {
                        return (
                            !col.hidden && (
                                <MobileTileRow
                                    key={'mobile-cell-' + ci}
                                    row={row}
                                    col={col}
                                    expanded={expanded}
                                    onExpand={() => setExpanded(!expanded)}
                                />
                            )
                        )
                    })}
                    {expanded && (
                        <MobileContainer>
                            <ExpandedRowComponent
                                item={row}
                                expanded={expanded}
                            />
                        </MobileContainer>
                    )}
                </TileDataBlock>
            </TileTable>
        </MobileTileMainContainer>
    )
}

const MobileTileMainContainer = styled.div`
    width: 100%;
    display: none;
    overflow: hidden;
    @media (max-width: 768px) {
        display: block;
    }
`

const TileTable = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 20px;
`

const TileHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 64px;
    padding: 0 12px;
    color: #ffffff;
    border-bottom: 1px solid grey;
    background-color: rgb(152, 135, 152);
`

const MobileContainer = styled.div`
    width: 100%;
    /* border: 1px solid #000; */
`

const TileDataBlock = styled.div`
    display: flex;
    padding: 8px;
    flex-direction: column;
    background-color: #fff;
    justify-content: flex-end;
    border: 1px solid grey;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
`

const TileData = styled.div`
    text-align: right;
    display: inline-flex;
    flex-direction: column;
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
`
const VersionsListContainer = styled.div``
const VersionItem = styled.div``
